<template>
  <div class="container" :class="type">
    <div class="info">
      <slot name="info"></slot>
    </div>
    <slot name="actions"></slot>
  </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'warning'
        },
    }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors.scss';
@import '~@/assets/styles/variables.scss';

.container {
  border-radius: $border-radius;
  padding: 16px 20px;
  display: flex;
  font-size: 14px;
}

.info {
  flex: 1;
  display: flex;
  align-items: center;
}

.warning {
  border: 1px solid $yellow;
  background-color: $light-yellow;
}

.error {
  border: 1px solid #e95555;
  background-color: rgba(233, 85, 85, 0.06);
}
</style>